<template>
  <section class="all-cases-view">
    <el-row justify="center">
      <el-col :span="20">
        <div class="container-default">
          <div class="listings-navbar">
            <el-row>
              <el-col :lg="7">
                <ul class="d-flex list-items-group-15 barcode-print">
                  <li>
                    <el-button
                      class="btn button-with-icon"
                      @click="addNewTests"
                    >
                      <span class="mr-8">
                        <img
                          src="@/assets/images/icons/plus-icon.svg"
                          alt="icon"
                          class="inactive"
                        />
                        <img
                          src="@/assets/images/icons/plus-icon-white.svg"
                          alt="icon"
                          class="active"
                        />
                      </span>
                      <span>ADD TEST</span>
                    </el-button>
                  </li>
                </ul>
              </el-col>
            </el-row>
          </div>
          <div class="primary-content-view-new" v-loading="loading">
            <div
              class="listings listings__table listings__all-cases"
              id="all-cases-listings"
            >
              <el-table
                :data="testData.data"
                :default-sort="{
                  prop: orderBy,
                  order: orderType == 'asc' ? 'ascending' : 'descending',
                }"
                @sort-change="onChangeSort"
              >
                <el-table-column
                  prop="name"
                  label="Test Name"
                  min-width="120"
                  sortable="custom"
                >
                  <template v-slot="scope"
                    ><span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="case_type"
                  label="Case Type"
                  min-width="150"
                >
                  <template v-slot="scope">{{
                    scope.row.case_type ? scope.row.case_type : "--"
                  }}</template>
                </el-table-column>

                <el-table-column label="Status" prop="status" min-width="90">
                  <template v-slot="scope">
                    {{ scope.row.status ? scope.row.status : "--" }}
                  </template>
                </el-table-column>
                <el-table-column
                  label=" Created At"
                  prop="created_at"
                  min-width="90"
                  sortable="custom"
                >
                  <template v-slot="scope">
                    <div v-if="scope.row.created_at" class="d-flex">
                      <div class="date pr-10">
                        {{
                          momentWithTimezone(scope.row.created_at, "MM-DD-yyyy")
                        }}
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="action"
                  label="ACTIONS"
                  fixed="right"
                  width="160"
                >
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li @click="onView(scope.row)">
                        <el-button class="view-button">
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/view-icon.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/view-inactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                      <li>
                        <el-button
                          class="delete-button"
                          @click="onDelete(scope.row._id)"
                          title="Delete Sendout"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/delete-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/delete-deactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
              <div class="listings listings__pagination">
                <el-pagination
                  v-model:currentPage="page"
                  v-model:page-size="pageSize"
                  :page-sizes="[20, 50, 80, 100]"
                  :small="small"
                  :disabled="disabled"
                  :background="background"
                  layout=" prev, pager, next, jumper, sizes ,total"
                  :total="testData.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </div>
          <ResonForChange
            v-if="takeReasonDialog"
            v-on:close="takeReasonDialog = false"
            v-on:reasonSubmit="deleteTestConfig"
            title="Reason for Archive"
          ></ResonForChange>
        </div>
      </el-col>
    </el-row>
  </section>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import { mapGetters } from "vuex";
import FilterHelper from "@/mixins/FilterHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper, FilterHelper],

  data() {
    return {
      page: 1,
      loading: false,
      pageSize: 20,
      testData: {},
      total: 0,
      orderBy: "created_at",
      orderType: "desc",
    };
  },
  computed: {
    ...mapGetters("bloodOtherTests", [
      "getAllOtherTests",
      "getTestDeleteStatus",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
  },

  async mounted() {
    await this.setQueryParams();
    await this.fetchAllTests();
  },

  methods: {
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllTests(this.page);
      }, 600);
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.fetchAllTests(this.page);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllTests(this.page);
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllTests(this.page);
    },
    setQueryParams() {
      this.page = this.$route.query.selectedConfigPage;

      if (this.$route.query.selectedConfigPageSize) {
        this.pageSize = parseInt(this.$route.query.selectedConfigPageSize);
      }
    },
    searchString() {
      setTimeout(() => {
        this.fetchAllTests(1);
      }, 500);
    },
    prepareParams(page) {
      let params = { page: page, limit: this.pageSize };

      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }

      return params;
    },

    async fetchAllTests(page, applyQuery = true) {
      this.page = page;
      this.loading = true;
      let params = this.prepareParams(page);
      await this.$store.dispatch("bloodOtherTests/fetchAllOtherTests", params);
      this.testData = JSON.parse(JSON.stringify(this.getAllOtherTests));
      if (applyQuery) {
        this.updateQueryParams(params);
      } else {
        this.updateQueryParam(this.$route.name, {}, true);
      }
      this.loading = false;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedConfigPage: params.page,

        selectedConfigPageSize: params.limit,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },

    async addNewTests() {
      this.$router.push({
        name: "AddClinicalChemistryConfig",
      });
    },
    onView(row) {
      this.loading = true;
      this.$router.push({
        name: "Clinical-Chemistry-Test-Update",
        params: { test_id: row._id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
      this.loading = false;
    },
    async onDelete(id) {
      this.$confirm("Are you sure to delete test?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deleteTest(id);
      });
    },
    async deleteTest(id) {
      try {
        await this.$store.dispatch("bloodOtherTests/deleteTest", id);
        if (this.getTestDeleteStatus) {
          successNotification("Test Removed successfully");

          this.loading = true;

          await this.fetchAllTests();

          this.loading = false;
        } else {
          errorNotification(this.getError || "Error while Removing Test");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss"></style>
